import { render } from "./double.vue?vue&type=template&id=8a53287c&scoped=true"
import script from "./double.vue?vue&type=script&lang=js"
export * from "./double.vue?vue&type=script&lang=js"

import "./double.vue?vue&type=style&index=0&id=8a53287c&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a53287c"]])

export default __exports__